import React, { useEffect, useState } from 'react';
import { useToast } from '../../contexts/ToastContext';

const Toast = ({ toast }) => {
  const { removeToast } = useToast();
  const [isVisible, setIsVisible] = useState(false);
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    // Trigger entrance animation
    const timer = setTimeout(() => setIsVisible(true), 10);
    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setIsExiting(true);
    setTimeout(() => removeToast(toast.id), 300);
  };

  const getToastIcon = () => {
    switch (toast.type) {
      case 'success':
        return '✅';
      case 'error':
        return '❌';
      case 'warning':
        return '⚠️';
      case 'info':
        return 'ℹ️';
      case 'loading':
        return '⏳';
      default:
        return 'ℹ️';
    }
  };

  const getToastClass = () => {
    let baseClass = 'toast';
    baseClass += ` toast-${toast.type}`;
    if (isVisible && !isExiting) baseClass += ' toast-visible';
    if (isExiting) baseClass += ' toast-exiting';
    return baseClass;
  };

  return (
    <div className={getToastClass()}>
      <div className="toast-content">
        <div className="toast-icon">
          {toast.type === 'loading' ? (
            <div className="loading-spinner-small"></div>
          ) : (
            getToastIcon()
          )}
        </div>
        
        <div className="toast-body">
          {toast.title && (
            <div className="toast-title">{toast.title}</div>
          )}
          <div className="toast-message">{toast.message}</div>
          
          {(toast.action || toast.cancelAction) && (
            <div className="toast-actions">
              {toast.action && (
                <button 
                  className="toast-action primary"
                  onClick={() => {
                    toast.action.onClick();
                    handleClose();
                  }}
                >
                  {toast.action.label}
                </button>
              )}
              {toast.cancelAction && (
                <button 
                  className="toast-action secondary"
                  onClick={() => {
                    toast.cancelAction.onClick();
                    handleClose();
                  }}
                >
                  {toast.cancelAction.label}
                </button>
              )}
            </div>
          )}
        </div>
        
        <button 
          className="toast-close"
          onClick={handleClose}
          aria-label="Close notification"
        >
          ×
        </button>
      </div>
      
      {toast.duration > 0 && (
        <div 
          className="toast-progress"
          style={{ 
            animationDuration: `${toast.duration}ms`,
            animationPlayState: isExiting ? 'paused' : 'running'
          }}
        ></div>
      )}
    </div>
  );
};

const ToastContainer = () => {
  const { toasts } = useToast();

  if (toasts.length === 0) return null;

  return (
    <div className="toast-container">
      {toasts.map(toast => (
        <Toast key={toast.id} toast={toast} />
      ))}
    </div>
  );
};

export default ToastContainer;